/* eslint-disable import/prefer-default-export */
export const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
export const EMAIL_LOGIN_REGEX = /^[\w+.-]+@([\w-]+\.)+[\w-]{2,4}$/
